import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import App from './App.tsx'
import './index.css'
import { createHashRouter, RouterProvider } from 'react-router-dom';
import ReactGA from 'react-ga4';
import './sentry'

const queryClient = new QueryClient();
const router = createHashRouter([
  {
    path: "/*",
    element: <App />,
  }
]);

//【GoogleAnalytics】初期化
ReactGA.initialize('G-VJNG8HCXH7');

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  </StrictMode>,
)
